import { render, staticRenderFns } from "./RiskCaseTag.vue?vue&type=template&id=86fabe3e&scoped=true"
import script from "./RiskCaseTag.vue?vue&type=script&lang=js"
export * from "./RiskCaseTag.vue?vue&type=script&lang=js"
import style0 from "./RiskCaseTag.vue?vue&type=style&index=0&id=86fabe3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fabe3e",
  null
  
)

export default component.exports